// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"22":"fb5ee1cc","208":"c462d8d3","242":"6554105c","289":"7016f366","317":"aed7f0cc","360":"aab71e74","369":"b9294ccc","418":"e50627b4","440":"6a7696b3","510":"0a64c5f1","796":"90411021"}[chunkId] + ".js";
};